import { render } from "./FiscalPeriodsContent.vue?vue&type=template&id=6112e7af&ts=true"
import script from "./FiscalPeriodsContent.vue?vue&type=script&lang=ts"
export * from "./FiscalPeriodsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__